export default __webpack_public_path__ + "static/5-1f0c5793efd85c20906dfa135828bea8.png";